import { logUsage } from 'owa-analytics';
import type AttachmentWellViewState from '../schema/AttachmentWellViewState';

export default function getAvailableLocalAttachmentSize(
    viewState: AttachmentWellViewState
): number {
    const availableSize =
        viewState.maxTotalClassicAttachmentSize - viewState.totalClassicAttachmentSize;
    if (availableSize < 0) {
        logUsage('AttachmentSizeReachedMax', {}, { isCore: true });
        return 0;
    } else {
        return availableSize;
    }
}
